import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import * as React from "react";

interface State {
  hasError: boolean;
}

interface Props {
  children: React.ReactNode;
}

const ProdEnv = process.env.NODE_ENV === "production";

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  componentDidCatch(error: Error) {
    console.log(error);

    this.setState({
      hasError: true,
    });
  }

  render() {
    if (this.state.hasError && ProdEnv) {
      return (
        <Card>
          <CardContent>
            <Typography color="secondary">Something went wrong.</Typography>
          </CardContent>
        </Card>
      );
    }

    return <>{this.props.children}</>;
  }
}
